/* eslint-disable react/prop-types */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import FormWrapper from '../../shared/components/form/FormWrapper';

const Form = ({ match: { params } }) => (
  <Container>
    <FormWrapper
      initialValues={{}}
      formUrlSuffix={`/${params.id}/create_return_label`}
      formTitle="Create Label Confirmation"
      formSubTitle={`Please confirm that you would like to create a label for Shipment #${params.id}`}
      successModalTitle="Label Created!"
      successModalMessage="You'll be sent back to the Shipment index page"
      submitButtonText="Confirm Create"
      successUrl="/orders/sales-shipments"
    />
  </Container>
);

export default withRouter(connect()(Form));
